import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { formatTime } from 'chameleon/packages/blue-book-player/utils';
import Modal from 'chameleon/packages/blue-book-player/library/modal';
import Icon from 'chameleon/packages/blue-book-player/library/icon';
import BlueBookButton from 'chameleon/packages/blue-book-player/library/bluebook-button/BlueBookButton';

const PauseScreen = (props) => {
  const titleRef = useRef(null);
  const { quizTitle, remainingTime, fullName, resumeTest } = props;

  useEffect(() => {
    if (titleRef?.current) {
      titleRef.current.focus();
    }
  }, [titleRef]);

  return (
    <Modal
      size="full"
      title=""
      dialogClassName="z-blueBook_pauseScreen"
      showCloseButton={false}
      contentWithSpacing={false}
      headerWithBorder={false}
      wrapperClassName="border-none"
      data-cy="pause-screen"
    >
      <div className="w-full h-full bg-gray-900">
        <div className="w-full h-full grid gap-[20px] grid-cols-2 px-[20px]">
          <div className="flex flex-col justify-center items-center p-[20px] -translate-y-[32px]">
            <div className="flex items-center mb-[20px] align-middle w-[274px] font-bold text-14">
              <Icon id="pause_screen_quiz_title" />
              <div className="flex items-center ml-[6px] align-middle text-white">
                {quizTitle}
              </div>
            </div>
            <div className="pt-[24px] pb-[12px] border border-white text-center w-[274px] h-[143px] rounded-[8px]">
              <section className="w-full h-full">
                <span className="text-16 break-words font-bold text-white h-auto">
                  Remaining Test Time:
                </span>
                <div className="flex justify-center h-[86px] items-center text-[72px] font-[500] px-[15px] text-white">
                  {formatTime(remainingTime)}
                </div>
              </section>
            </div>
            <div className="bottom-[24px] text-20 left-[41px] max-w-[calc(50%-41px)] overflow-hidden absolute text-ellipsis whitespace-nowrap text-white">
              {fullName}
            </div>
          </div>
          <div className="flex flex-col justify-center p-[20px] text-white">
            <div className="max-h-full pt-[16px]">
              <h1
                className="font-medium text-[32px] leading-normal mb-[8px]"
                ref={titleRef}
              >
                Testing Is Paused: Do Not Close Your Device
              </h1>
              <p className="text-20 font-light leading-[1.6] mt-[16px] mb-[24px] max-w-[408px]">
                When you resume testing, the timer will start up again.
              </p>
              <BlueBookButton
                isWarning
                size="custom"
                className="!font-bold w-[150px] h-[48px]"
                onClick={resumeTest}
                data-test-id="resume-test-button"
                data-cy="resume-test-button"
              >
                Resume Testing
              </BlueBookButton>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

PauseScreen.propTypes = {
  quizTitle: PropTypes.string,
  remainingTime: PropTypes.number,
  fullName: PropTypes.string,
  resumeTest: PropTypes.func,
};

PauseScreen.defaultProps = {
  quizTitle: '',
  remainingTime: 0,
  fullName: '',
  resumeTest: () => {},
};

export default PauseScreen;
